/* unplugin-vue-components disabled */import { render } from "./Exchange.vue?vue&type=template&id=3d4da3b5"
const script = {}

import "./Exchange.vue?vue&type=style&index=0&id=3d4da3b5&lang=scss"

import exportComponent from "../../../../common/temp/node_modules/.pnpm/vue-loader@17.2.2_3tnefydtqxjg44ddub7xm4i2wi/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__